import React, { Fragment } from "react";
import {
  List,
  Datagrid,
  Filter,
  EditButton,
  Button,
  TextInput,
  TextField,
  FunctionField,
  ShowButton,
  useRecordContext,
  Link,
  Pagination,
  TopToolbar,
  ChipField
} from "react-admin";
import BulkActiveButton from '../UploadPaymentProof/Action/Bulk.Active.Button';

// import BulkRejectButton from '../WithdrawRequest/Action/Bulk.Reject.Button';
import DownloadIcon from '@material-ui/icons/GetApp';
import { UploadPaymentProofStatusSelectInput, UploadPaymentProofPaymentTypeSelectInput } from '../../UI/Input/SelectInput'

const PostPagination = () => <Pagination rowsPerPageOptions={[10, 25, 50, 100, 200, 300, 400, 500, 1000, 2000]} />;

const BulkActionButtons = ({ ...props }) => {

  return (<Fragment>
    <BulkActiveButton label="Bulck Active"  {...props} />
    {/* <BulkRejectButton label="Bulck Reject"  {...props} /> */}

  </Fragment>)
}
const ProfileidFiled = (props) => {
  const record = useRecordContext();
  return (
    <TextField {...props} component={Link} to={`/user?filter={"q":"${record.profile_id}"}`} onClick={(event) => event.stopPropagation()} />
  )
}



const ListFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="q" alwaysOn />
    <UploadPaymentProofStatusSelectInput label="Status" source="status" alwaysOn />
    <UploadPaymentProofPaymentTypeSelectInput label="Payment Type" source="payment_type" alwaysOn />
  </Filter>
);
////www.stage.tiruvannamalaiproperties.in/api/v1/1/customers/export?
const ListActions = () => (
  <TopToolbar>
    <Button href={'//sboportal.org.in/admin/api/v1/widthdraw/export?'} label="Export" ><DownloadIcon /></Button>
  </TopToolbar>
);

const UploadPaymentProofList = ({ ...props }) => {

  return (
    <Fragment>
      <List
        {...props}

        title="Uploaded Payment Proof"
        filters={<ListFilter />}
        bulkActionButtons={<BulkActionButtons />}
        sort={{ field: "name", order: "ASC" }}
        // actions={<ListActions />}
        pagination={<PostPagination />}
      >
        <Datagrid >
          <TextField source="id" />
          <ProfileidFiled source="profile_id" label="Profile Id" />
          <TextField source="name" label="Name" />
          <TextField source="payment_credited_date" label="Payment Credited Date" />
          <TextField source="payment_type" label="Payment Type" />
          <TextField source="request_amount" label="Request Amount" />
          <TextField source="received_amount" label="Received Amount" />
          <FunctionField source="credited_proof" label="Proof" render={record => {           
            if (record['credited_proofurl']) {
              return (<span>Proof <br /><br /><img style={{ maxWidth: '100px' }} src={record['credited_proofurl']} alt={record.name} /></span>)
            }
          }} />
          <FunctionField source="status" label="Status" render={record => {
            if (record['status'] === 'Rejected') {
              return (<Button style={{ color: 'red', border: '1px solid' }} label="Rejected" size="small"></Button>)
            } else if (record['status'] === 'Pending') {
              return (<Button style={{ color: 'orange', border: '1px solid' }} label="Pending" size="small"></Button>)
            } else if (record['status'] === 'Published') {
              return (<Button style={{ color: 'green', border: '1px solid' }} label="Published" size="small"></Button>)
            }
          }} />
          <FunctionField source="status" label="Edit Action" render={record => {
            if (record['status'] != 'Rejected') {
              return (<EditButton />)
            }

          }} />
          <ShowButton />
        </Datagrid>
      </List>

    </Fragment>
  );
};

export default UploadPaymentProofList;
